import { useContext, useEffect } from "react";
import {Link} from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const PharmaciesPage = () => {

  const { getPharmacies, pharmacies } = useContext(AdminContext);

  

  useEffect(() => {
    getPharmacies();
   document.title = 'Аптеки'
 
  }, []);
  return (
    <div className="container">
      <div className="admin__user__results">
        <ButtonBack />
        <Link to="/admin/pharmacies/add" className="admin__results__link">
          Добавить аптеку
        </Link>
        <div className="admin__user__title">Аптеки</div>

        <div className="admin__user__items">
          {!pharmacies ? (
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          ) : (
            pharmacies.map((ph) => (
              <div className="admin__user__item" key={ph.id}>
                <Link
                  to={`/admin/pharmacies/${ph.id}`}
                  className="admin__menu__item"
                >
                  {ph.short_name}
                </Link>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default PharmaciesPage;
